(function () {
  "use strict";

  function formatMoney(pence) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP"
    }).format((Number(pence) || 0) / 100);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function sanitizeLargeText(value) {
    let cleaned = String(value || "")
      .toUpperCase()
      .replace(/[^A-Z0-9 .&'-]/g, "")
      .replace(/\s+/g, " ")
      .replace(/^\s+/, "");

    return cleaned.slice(0, 14);
  }

  function sanitizeSmallText(value) {
    let cleaned = String(value || "")
      .replace(/[^A-Za-z0-9 .,&'!?:+-]/g, "")
      .replace(/\s+/g, " ")
      .replace(/^\s+/, "");

    return cleaned.slice(0, 55);
  }

  function slugStyle(style) {
    return String(style || "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  function parsePrefill() {
    const params = new URLSearchParams(window.location.search);

    return {
      text: params.get("text") || params.get("reg") || "",
      message: params.get("message") || "",
      style: params.get("style") || "",
      size: params.get("size") || "",
      badge: params.get("badge") || "",
      border: params.get("border") || "",
      face: params.get("face") || ""
    };
  }

  function getHexMetrics() {
    return {
      topInsetRatio: 17.5 / 520,
      bottomInsetRatio: 25 / 520,
      sidePointYRatio: 32 / 111
    };
  }

  function getHexOverlayBoost(sizeKey) {
    if (sizeKey === "Hex 7") return 14;
    if (sizeKey === "Hex 6") return 20;
    if (sizeKey === "Hex 5") return 26;
    return 0;
  }

  function getHexOverlayOverscan(sizeKey) {
    if (sizeKey === "Hex 7") return 20;
    if (sizeKey === "Hex 6") return 26;
    if (sizeKey === "Hex 5") return 36;
    return 8;
  }

  function getBorderInsetMm(sizeConfig) {
    if (sizeConfig.shape === "hex") return 0;
    return 8;
  }

  function buildPlateShapeSvg(sizeConfig, fill) {
    return '<rect x="0" y="0" width="' + sizeConfig.widthMm + '" height="' + sizeConfig.heightMm + '" rx="4" ry="4" fill="' + fill + '"/>';
  }

  function buildHexOverlaySvg(sizeConfig, sizeKey, overlayFill) {
    if (sizeConfig.shape !== "hex") return "";

    const w = sizeConfig.widthMm;
    const h = sizeConfig.heightMm;
    const hex = getHexMetrics();
    const boost = getHexOverlayBoost(sizeKey);
    const overscan = getHexOverlayOverscan(sizeKey);

    const topInset = (w * hex.topInsetRatio) + boost;
    const bottomInset = (w * hex.bottomInsetRatio) + boost;
    const sidePointY = h * hex.sidePointYRatio;

    let svg = "";

    svg += '<polygon points="' +
      (-overscan) + ',' + (-overscan) + ' ' +
      topInset + ',' + (-overscan) + ' ' +
      '0,' + sidePointY + ' ' +
      bottomInset + ',' + (h + overscan) + ' ' +
      (-overscan) + ',' + (h + overscan) +
      '" fill="' + overlayFill + '"/>';

    svg += '<polygon points="' +
      (w + overscan) + ',' + (-overscan) + ' ' +
      (w - topInset) + ',' + (-overscan) + ' ' +
      w + ',' + sidePointY + ' ' +
      (w - bottomInset) + ',' + (h + overscan) + ' ' +
      (w + overscan) + ',' + (h + overscan) +
      '" fill="' + overlayFill + '"/>';

    return svg;
  }

  function buildSvgTextContent(displayText) {
    const parts = String(displayText || "").split(" ");

    if (parts.length === 2) {
      return '<tspan>' + escapeHtml(parts[0]) + '</tspan>' +
        '<tspan dx="0.12em">' + escapeHtml(parts[1]) + '</tspan>';
    }

    return escapeHtml(displayText);
  }

  function buildTextElement(displayText, options) {
    let svg = "";

    svg += '<text';
    svg += ' x="' + options.x + '"';
    svg += ' y="' + options.y + '"';
    svg += ' text-anchor="middle"';
    svg += ' font-family="CharlesWrightMuzz, Charles Wright, Arial Narrow, Arial, sans-serif"';
    svg += ' font-size="' + options.fontSize + '"';
    svg += ' font-weight="400"';
    svg += ' letter-spacing="' + options.letterSpacing + 'em"';
    svg += ' text-rendering="geometricPrecision"';
    svg += ' dominant-baseline="alphabetic"';

    if (options.fill !== undefined) svg += ' fill="' + options.fill + '"';
    if (options.stroke !== undefined) svg += ' stroke="' + options.stroke + '"';
    if (options.strokeWidth !== undefined) svg += ' stroke-width="' + options.strokeWidth + '"';
    if (options.strokeLinejoin) svg += ' stroke-linejoin="' + options.strokeLinejoin + '"';
    if (options.strokeLinecap) svg += ' stroke-linecap="' + options.strokeLinecap + '"';
    if (options.opacity !== undefined) svg += ' opacity="' + options.opacity + '"';
    if (options.filter) svg += ' filter="' + options.filter + '"';

    svg += '>';
    svg += buildSvgTextContent(displayText);
    svg += '</text>';

    return svg;
  }

  function buildStyleDefs(id) {
    let svg = "";

    svg += '<defs>';

    svg += '<filter id="' + id + 'SoftRaise" x="-20%" y="-30%" width="140%" height="170%">';
    svg += '<feDropShadow dx="1.2" dy="1.8" stdDeviation="1" flood-color="#000000" flood-opacity="0.55"/>';
    svg += '</filter>';

    svg += '<filter id="' + id + 'HardRaise" x="-20%" y="-30%" width="140%" height="170%">';
    svg += '<feDropShadow dx="0.9" dy="1.1" stdDeviation="0.35" flood-color="#000000" flood-opacity="0.55"/>';
    svg += '</filter>';

    svg += '<linearGradient id="' + id + 'BlackGloss" x1="0%" y1="0%" x2="0%" y2="100%">';
    svg += '<stop offset="0%" stop-color="#444444"/>';
    svg += '<stop offset="18%" stop-color="#1b1b1b"/>';
    svg += '<stop offset="54%" stop-color="#020202"/>';
    svg += '<stop offset="100%" stop-color="#181818"/>';
    svg += '</linearGradient>';

    svg += '<filter id="' + id + 'BevelAcrylic" x="-20%" y="-30%" width="140%" height="170%" color-interpolation-filters="sRGB">';
    svg += '<feGaussianBlur in="SourceAlpha" stdDeviation="1.2" result="blur"/>';
    svg += '<feSpecularLighting in="blur" surfaceScale="4" specularConstant="0.9" specularExponent="18" lighting-color="#ffffff" result="spec">';
    svg += '<fePointLight x="-500" y="-900" z="900"/>';
    svg += '</feSpecularLighting>';
    svg += '<feComposite in="spec" in2="SourceAlpha" operator="in" result="specOut"/>';
    svg += '<feOffset in="SourceAlpha" dx="1.1" dy="1.3" result="shadowOffset"/>';
    svg += '<feGaussianBlur in="shadowOffset" stdDeviation="0.45" result="shadowBlur"/>';
    svg += '<feFlood flood-color="#000000" flood-opacity="0.55" result="shadowColor"/>';
    svg += '<feComposite in="shadowColor" in2="shadowBlur" operator="in" result="shadow"/>';
    svg += '<feMerge>';
    svg += '<feMergeNode in="shadow"/>';
    svg += '<feMergeNode in="SourceGraphic"/>';
    svg += '<feMergeNode in="specOut"/>';
    svg += '</feMerge>';
    svg += '</filter>';

    svg += '</defs>';

    return svg;
  }

  function buildStyledLargeTextSvg(displayText, style, x, y, fontSize, letterSpacing, id) {
    const styleKey = slugStyle(style);
    let svg = buildStyleDefs(id);

    if (styleKey === "4d-obsidian") {
      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#020202",
        stroke: "#111111",
        strokeWidth: 4.4,
        strokeLinejoin: "round",
        strokeLinecap: "round",
        filter: "url(#" + id + "HardRaise)"
      });

      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#050505",
        stroke: "#242424",
        strokeWidth: 1.2,
        strokeLinejoin: "round"
      });

      return svg;
    }

    if (styleKey === "4d-ghost") {
      svg += buildTextElement(displayText, {
        x: x + 0.7,
        y: y + 0.9,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#000000",
        opacity: 0.42,
        filter: "url(#" + id + "HardRaise)"
      });

      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#050505",
        stroke: "#1f1f1f",
        strokeWidth: 1.6,
        strokeLinejoin: "round"
      });

      svg += buildTextElement(displayText, {
        x: x - 0.35,
        y: y - 0.4,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "none",
        stroke: "#6c6c6c",
        strokeWidth: 1.2,
        strokeLinejoin: "round",
        opacity: 0.65
      });

      svg += buildTextElement(displayText, {
        x: x + 0.45,
        y: y + 0.45,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "none",
        stroke: "#000000",
        strokeWidth: 1.4,
        strokeLinejoin: "round",
        opacity: 0.85
      });

      return svg;
    }

    if (styleKey === "4d-bevelled-edge") {
      svg += buildTextElement(displayText, {
        x: x + 2.2,
        y: y + 2.6,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#000000",
        opacity: 0.34,
        filter: "url(#" + id + "SoftRaise)"
      });

      svg += buildTextElement(displayText, {
        x: x + 1.15,
        y: y + 1.25,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#050505",
        opacity: 0.92
      });

      svg += buildTextElement(displayText, {
        x: x - 0.9,
        y: y - 0.9,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#3d3d3d",
        opacity: 0.72
      });

      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize * 0.91,
        letterSpacing: letterSpacing + 0.004,
        fill: "url(#" + id + "BlackGloss)"
      });

      svg += buildTextElement(displayText, {
        x: x - 0.45,
        y: y - 0.65,
        fontSize: fontSize * 0.82,
        letterSpacing: letterSpacing + 0.006,
        fill: "#ffffff",
        opacity: 0.12
      });

      return svg;
    }

    if (styleKey === "3d-gel") {
      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#050505",
        stroke: "#000000",
        strokeWidth: 0.8,
        strokeLinejoin: "round",
        filter: "url(#" + id + "BevelAcrylic)"
      });

      return svg;
    }

    if (styleKey === "4d-acrylic") {
      svg += buildTextElement(displayText, {
        x: x + 2,
        y: y + 2.2,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#000000",
        opacity: 0.55
      });

      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#050505",
        filter: "url(#" + id + "HardRaise)"
      });

      return svg;
    }

    if (styleKey === "5d") {
      svg += buildTextElement(displayText, {
        x: x,
        y: y,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        fill: "#050505",
        stroke: "#000000",
        strokeWidth: 1.2,
        strokeLinejoin: "round",
        filter: "url(#" + id + "BevelAcrylic)"
      });

      return svg;
    }

    return buildTextElement(displayText, {
      x: x,
      y: y,
      fontSize: fontSize,
      letterSpacing: letterSpacing,
      fill: "#111111"
    });
  }
function getSmallMessageGapWidthMm(message, sizeConfig, badge, rules) {
  const clean = String(message || "").trim();

  if (!clean) return 0;

  const hasBadge = badge && badge !== "None";
  const borderInset = getBorderInsetMm(sizeConfig);
  const leftLimit = hasBadge ? rules.badgeWidthMm + borderInset : borderInset;
  const rightLimit = sizeConfig.widthMm - borderInset;
  const maxGapWidth = Math.max(0, rightLimit - leftLimit - 12);

  /*
    Approximate visual width of the small Arial message.
    It does not need to be perfect, it just needs to keep the border clear of the text.
  */
  const estimatedTextWidth = clean.length * 5.2;
  const paddedGapWidth = estimatedTextWidth + 34;

  return Math.min(
    Math.max(paddedGapWidth, 70),
    maxGapWidth
  );
}
function buildBorderSvg(sizeConfig, borderMm, badge, rules, messageCenterX, smallMessage) {
  if (!borderMm || sizeConfig.shape === "hex") return "";

  const inset = getBorderInsetMm(sizeConfig);
  const left = inset;
  const top = inset;
  const right = sizeConfig.widthMm - inset;
  const bottom = sizeConfig.heightMm - inset;
  const hasBadge = badge && badge !== "None";

  const borderLeft = hasBadge ? rules.badgeWidthMm + inset : left;
  const messageGapWidth = getSmallMessageGapWidthMm(smallMessage, sizeConfig, badge, rules);
  const gapCenter = messageCenterX || (sizeConfig.widthMm / 2);

  const rawGapStart = gapCenter - (messageGapWidth / 2);
  const rawGapEnd = gapCenter + (messageGapWidth / 2);

  const gapStart = Math.max(borderLeft + 4, rawGapStart);
  const gapEnd = Math.min(right - 4, rawGapEnd);

  let svg = "";

    if (!hasBadge) {
      svg += '<line x1="' + left + '" y1="' + top + '" x2="' + right + '" y2="' + top + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      svg += '<line x1="' + right + '" y1="' + top + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      svg += '<line x1="' + left + '" y1="' + top + '" x2="' + left + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
if (messageGapWidth > 0 && gapEnd > gapStart) {
  svg += '<line x1="' + left + '" y1="' + bottom + '" x2="' + gapStart + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
  svg += '<line x1="' + gapEnd + '" y1="' + bottom + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
} else {
  svg += '<line x1="' + left + '" y1="' + bottom + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
}

return svg;
    }

    const borderStartX = rules.badgeWidthMm + inset;

    svg += '<line x1="' + borderStartX + '" y1="' + top + '" x2="' + right + '" y2="' + top + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
    svg += '<line x1="' + right + '" y1="' + top + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
    svg += '<line x1="' + borderStartX + '" y1="' + top + '" x2="' + borderStartX + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
if (messageGapWidth > 0 && gapEnd > gapStart) {
  svg += '<line x1="' + borderStartX + '" y1="' + bottom + '" x2="' + gapStart + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
  svg += '<line x1="' + gapEnd + '" y1="' + bottom + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
} else {
  svg += '<line x1="' + borderStartX + '" y1="' + bottom + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
}

return svg;
  }

  function getTextArea(sizeConfig, rules, badge) {
    const hasBadge = badge && badge !== "None";

    if (!hasBadge || sizeConfig.shape === "hex") {
      return {
        startX: 14,
        endX: sizeConfig.widthMm - 14
      };
    }

    return {
      startX: rules.badgeWidthMm + 10,
      endX: sizeConfig.widthMm - 14
    };
  }

  function getTextCenterX(sizeConfig, rules, badge) {
    const area = getTextArea(sizeConfig, rules, badge);
    return area.startX + ((area.endX - area.startX) / 2);
  }
function getNoveltyCharWidthMm(char) {
  const widths = {
    "1": 18,
    "I": 14,
    "J": 26,
    "L": 30,
    "T": 34,
    "M": 48,
    "W": 48,
    " ": 28,
    ".": 12,
    "'": 10,
    "-": 22,
    "&": 42
  };

  if (widths[char] != null) return widths[char];
  if (/[0-9]/.test(char)) return 40;
  return 43;
}

function getNoveltyTextWidthMm(text) {
  const clean = String(text || "").toUpperCase();
  let width = 0;

  clean.split("").forEach(function (char, index) {
    width += getNoveltyCharWidthMm(char);

    if (char !== " " && index < clean.length - 1) {
      width += 10;
    }
  });

  return width;
}

function getNoveltyAvailableTextWidthMm(sizeKey, sizeConfig, badge, rules) {
  const hasBadge = badge && badge !== "None";

  if (sizeConfig.shape === "hex") {
    if (sizeKey === "Hex 7") return 370;
    if (sizeKey === "Hex 6") return 320;
    if (sizeKey === "Hex 5") return 270;
    return 320;
  }

  const area = getTextArea(sizeConfig, rules, hasBadge ? badge : "None");
  return area.endX - area.startX;
}

function doesNoveltyTextFit(state, sizeKey, sizeConfig, rules) {
  const textWidthMm = getNoveltyTextWidthMm(state.largeText);
  const availableWidthMm = getNoveltyAvailableTextWidthMm(sizeKey, sizeConfig, state.badge, rules);

  return {
    fits: textWidthMm <= availableWidthMm,
    textWidthMm: textWidthMm,
    availableWidthMm: availableWidthMm
  };
}
function getMainFontSize() {
  return 95;
}

function getSmallMessageFontSize() {
  return 8;
}

function getFitState(state, sizeConfig, sizeKey, rules) {
  const warnings = [];
  let fitState = "green";
  let fitLabel = "Ready";

  if (!state.largeText) {
    fitState = "amber";
    fitLabel = "Add text";
    warnings.push({
      state: "amber",
      text: "Enter the large text you want on the sign."
    });
  } else {
    const textFit = doesNoveltyTextFit(state, sizeKey, sizeConfig, rules);

    if (!textFit.fits) {
      fitState = "red";
      fitLabel = "Text too long";
      warnings.push({
        state: "red",
        text: "This text is too long for the selected size. Choose a larger sign or shorten the wording."
      });
    } else {
      warnings.push({
        state: "green",
        text: "This is a decorative novelty sign, not a road-legal number plate."
      });
    }
  }

  if (sizeConfig.shape === "hex" && state.badge !== "None") {
    fitState = "red";
    fitLabel = "Badge not allowed";
    warnings.push({
      state: "red",
      text: "Flags and badges are only available on oblong plate shapes."
    });
  }

  if (sizeConfig.shape === "hex" && state.border !== "None") {
    fitState = "red";
    fitLabel = "Border not allowed";
    warnings.push({
      state: "red",
      text: "Borders are only available on oblong plate shapes."
    });
  }

  if (!state.notRoadUseAccepted && fitState !== "red") {
    fitState = "amber";
    fitLabel = "Confirm use";
    warnings.push({
      state: "amber",
      text: "Confirm that this is for decorative use only before adding to cart."
    });
  } else if (!state.notRoadUseAccepted) {
    warnings.push({
      state: "amber",
      text: "Confirm that this is for decorative use only before adding to cart."
    });
  }

  return {
    fitState: fitState,
    fitLabel: fitLabel,
    warnings: warnings
  };
}

  function buildSvgMarkup(state, config, sizeConfig, sizeKey, fit) {
    const rules = config.charRules;
    const badgeMap = config.badgeAssets[state.badge] || null;
    const badgeUrl = badgeMap ? (state.face === "White" ? badgeMap.white : badgeMap.yellow) : "";
    const bgFill = state.face === "White" ? "#e6eff5" : "#e79000";
    const overlayFill = "#15171c";
    const borderMm = sizeConfig.shape === "hex" ? 0 : (state.border === "None" ? 0 : parseInt(state.border, 10) || 0);
    const textCenterX = getTextCenterX(sizeConfig, rules, state.badge);
    const sectionSafeId = "muzzNovelty" + String(config.sectionId || "default").replace(/[^a-zA-Z0-9]/g, "");
    const largeText = state.largeText || "DAD CAVE";
    const smallMessage = state.smallText || "";
    const textY = sizeConfig.shape === "hex" ? 86 : 89;
    const messageY = sizeConfig.heightMm -10.5;
const fontSize = getMainFontSize();
const messageFontSize = getSmallMessageFontSize();
    const letterSpacing = 0.020;

    let svg = "";

    svg += '<svg xmlns="http://www.w3.org/2000/svg"';
    svg += ' viewBox="0 0 ' + sizeConfig.widthMm + " " + sizeConfig.heightMm + '"';
    svg += ' preserveAspectRatio="xMidYMid meet"';
    svg += ' style="position:absolute;inset:0;width:100%;height:100%;display:block;">';

    svg += '<defs>';
    svg += '<linearGradient id="' + sectionSafeId + 'PlateShine" x1="0%" y1="0%" x2="0%" y2="100%">';
    svg += '<stop offset="0%" stop-color="#ffffff" stop-opacity="0.08"/>';
    svg += '<stop offset="28%" stop-color="#ffffff" stop-opacity="0.035"/>';
    svg += '<stop offset="68%" stop-color="#000000" stop-opacity="0"/>';
    svg += '<stop offset="100%" stop-color="#000000" stop-opacity="0.025"/>';
    svg += '</linearGradient>';
    svg += '</defs>';

    svg += buildPlateShapeSvg(sizeConfig, bgFill);
    svg += '<rect x="0" y="0" width="' + sizeConfig.widthMm + '" height="' + sizeConfig.heightMm + '" rx="4" ry="4" fill="url(#' + sectionSafeId + 'PlateShine)" opacity="1"/>';

    if (state.badge !== "None" && badgeUrl && sizeConfig.shape !== "hex") {
      svg += '<image href="' + escapeHtml(badgeUrl) + '" x="0" y="0" width="' + rules.badgeWidthMm + '" height="' + sizeConfig.heightMm + '" preserveAspectRatio="xMidYMid meet"/>';
    }

svg += buildBorderSvg(sizeConfig, borderMm, state.badge, rules, textCenterX, smallMessage);

const previewStyle = slugStyle(state.style) === "4d-bevelled-edge"
  ? "2D Printed"
  : state.style;

svg += buildStyledLargeTextSvg(
  largeText,
  previewStyle,
  textCenterX,
  textY,
  fontSize,
  letterSpacing,
  sectionSafeId
);

    if (smallMessage) {
      svg += '<text x="' + textCenterX + '" y="' + messageY + '" text-anchor="middle" fill="#111111" font-family="Arial, sans-serif" font-size="' + messageFontSize + '" font-weight="700" letter-spacing="0.02em">' + escapeHtml(smallMessage.toUpperCase()) + '</text>';
    }

    if (sizeConfig.shape === "hex") {
      svg += buildHexOverlaySvg(sizeConfig, sizeKey, overlayFill);
    }

    svg += "</svg>";

    return svg;
  }

  function getProductImage(product) {
    if (!product) return "";

    if (typeof product.featured_image === "string" && product.featured_image) {
      return product.featured_image;
    }

    if (product.featured_image && typeof product.featured_image.src === "string" && product.featured_image.src) {
      return product.featured_image.src;
    }

    if (
      product.featured_media &&
      product.featured_media.preview_image &&
      typeof product.featured_media.preview_image.src === "string" &&
      product.featured_media.preview_image.src
    ) {
      return product.featured_media.preview_image.src;
    }

    if (Array.isArray(product.images) && product.images.length) {
      if (typeof product.images[0] === "string" && product.images[0]) {
        return product.images[0];
      }

      if (product.images[0] && typeof product.images[0].src === "string") {
        return product.images[0].src;
      }
    }

    return "";
  }

  function updateCartBubble() {
    return fetch("/cart.js", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart fetch failed");
        return response.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;
        var cartIconBubble = document.getElementById("cart-icon-bubble");

        if (!cartIconBubble) return;

        var existingBubble = cartIconBubble.querySelector(".cart-count-bubble");

        if (count > 0) {
          if (!existingBubble) {
            existingBubble = document.createElement("div");
            existingBubble.className = "cart-count-bubble";
            cartIconBubble.appendChild(existingBubble);
          }

          existingBubble.innerHTML =
            '<span aria-hidden="true">' + count + '</span>' +
            '<span class="visually-hidden">' + count + ' item' + (count === 1 ? "" : "s") + '</span>';
        } else if (existingBubble) {
          existingBubble.remove();
        }
      })
      .catch(function (error) {
        console.error("Cart bubble update failed:", error);
      });
  }

  function initBuilder(root) {
    const productEl = root.querySelector("[data-novelty-product]");
    const stylesEl = root.querySelector("[data-novelty-style-products]");
    const configEl = root.querySelector("[data-novelty-config]");

    if (!productEl || !configEl) return;

    const noveltyProduct = JSON.parse(productEl.textContent || "null");
    const styleProducts = stylesEl ? JSON.parse(stylesEl.textContent || "{}") : {};
    const config = JSON.parse(configEl.textContent || "{}");

    if (!noveltyProduct || !Array.isArray(noveltyProduct.variants) || !noveltyProduct.variants.length) return;

    config.sizes = {
      "Standard Size": { widthMm: 520, heightMm: 111, shape: "rect" },
      '18" Short': { widthMm: 457, heightMm: 111, shape: "rect" },
      '17" Short': { widthMm: 432, heightMm: 111, shape: "rect" },
      '16" Short': { widthMm: 406, heightMm: 111, shape: "rect" },
      '13" Short': { widthMm: 330, heightMm: 111, shape: "rect" },
      "Hex 7": { widthMm: 520, heightMm: 111, shape: "hex" },
      "Hex 6": { widthMm: 457, heightMm: 111, shape: "hex" },
      "Hex 5": { widthMm: 406, heightMm: 111, shape: "hex" }
    };

    const form = root.querySelector("[data-novelty-form]");
    const largeTextInput = root.querySelector('[data-novelty-input="largeText"]');
    const smallTextInput = root.querySelector('[data-novelty-input="smallText"]');
    const styleSelect = root.querySelector('[data-novelty-input="style"]');
    const faceSelect = root.querySelector('[data-novelty-input="face"]');
    const sizeSelect = root.querySelector('[data-novelty-input="size"]');
    const badgeSelect = root.querySelector('[data-novelty-input="badge"]');
    const borderSelect = root.querySelector('[data-novelty-input="border"]');
    const confirmInput = root.querySelector('[data-novelty-input="notRoadUseAccepted"]');
    const variantIdInput = root.querySelector("[data-novelty-variant-id]");
    const atcButton = root.querySelector("[data-novelty-atc]");
    const atcNote = root.querySelector("[data-novelty-atc-note]");
    const priceEl = root.querySelector("[data-novelty-price]");
    const warningsEl = root.querySelector("[data-novelty-warnings]");
    const fitEl = root.querySelector("[data-fit-status]");
    const fitLabelEl = root.querySelector("[data-fit-label]");
    const canvas = root.querySelector("[data-novelty-canvas]");
    const choiceButtons = root.querySelectorAll("[data-choice-target]");

function resolveVariant() {
  return noveltyProduct.variants.find(function (item) {
    return item.option1 === state.style;
  }) || null;
}

    const state = {
      largeText: "",
      smallText: "",
      style: "2D Printed",
      face: "Yellow",
      size: "Standard Size",
      badge: "None",
      border: "None",
      notRoadUseAccepted: false
    };

    const prefill = parsePrefill();

    if (prefill.text) state.largeText = sanitizeLargeText(prefill.text);
    if (prefill.message) state.smallText = sanitizeSmallText(prefill.message);
    if (prefill.style && (config.styles || []).includes(prefill.style)) state.style = prefill.style;
    if (prefill.size && config.sizes[prefill.size]) state.size = prefill.size;
    if (prefill.badge && (config.badges || []).includes(prefill.badge)) state.badge = prefill.badge;
    if (prefill.border && (config.borders || []).includes(prefill.border)) state.border = prefill.border;
    if (prefill.face && (config.faces || []).includes(prefill.face)) state.face = prefill.face;

    if (largeTextInput) largeTextInput.value = state.largeText;
    if (smallTextInput) smallTextInput.value = state.smallText;
    if (styleSelect) styleSelect.value = state.style;
    if (faceSelect) faceSelect.value = state.face;
    if (sizeSelect) sizeSelect.value = state.size;
    if (badgeSelect) badgeSelect.value = state.badge;
    if (borderSelect) borderSelect.value = state.border;

    function enforceBorderRules() {
      if (!borderSelect) return;

      const sizeConfig = config.sizes[state.size];
      const isHex = sizeConfig && sizeConfig.shape === "hex";

      Array.from(borderSelect.options).forEach(function (option) {
        option.disabled = false;
      });

      if (isHex) {
        state.border = "None";
        borderSelect.value = "None";

        Array.from(borderSelect.options).forEach(function (option) {
          if (option.value !== "None") option.disabled = true;
        });
      }
    }

    function enforceBadgeRules() {
      if (!badgeSelect) return;

      const sizeConfig = config.sizes[state.size];
      const isHex = sizeConfig && sizeConfig.shape === "hex";

      Array.from(badgeSelect.options).forEach(function (option) {
        option.disabled = false;
      });

      if (isHex) {
        state.badge = "None";
        badgeSelect.value = "None";

        Array.from(badgeSelect.options).forEach(function (option) {
          if (option.value !== "None") option.disabled = true;
        });
      }
    }

function renderWarnings(items) {
  if (!warningsEl) return;

  let warningItems = items.slice();

  if (slugStyle(state.style) === "4d-bevelled-edge") {
    warningItems.push({
      state: "amber",
      text: "Bevelled Edge preview mode is currently behaving like a potato. We’d rather show you a clean 2D-style preview than a bad fake bevel. Use the style photos as reference. The real thing catches light properly and looks far better in person."
    });
  }

  warningsEl.innerHTML = warningItems.map(function (item) {
    return '<div class="muzz-novelty-warning muzz-novelty-warning--' + escapeHtml(item.state) + '">' + escapeHtml(item.text) + '</div>';
  }).join("");
}

    function renderPreview(fit) {
      const sizeConfig = config.sizes[state.size];

      if (!canvas || !sizeConfig) return;

      const shell = canvas.parentElement;
      const shellStyles = window.getComputedStyle(shell);

      const shellInnerWidth =
        shell.getBoundingClientRect().width -
        parseFloat(shellStyles.paddingLeft || 0) -
        parseFloat(shellStyles.paddingRight || 0);

const previewBaseWidthPx = 640;
const previewReferenceWidthMm = 520;

/*
  Mobile-safe preview sizing:
  - Uses the real available shell width.
  - Never forces a minimum width bigger than the container.
  - Keeps all plates physically scaled against 520mm.
  - Short plates get narrower, height stays consistent.
*/
const availableWidth = Math.max(Math.floor(shellInnerWidth), 1);

const pxPerMm = Math.min(
  previewBaseWidthPx / previewReferenceWidthMm,
  availableWidth / previewReferenceWidthMm
);

const widthPx = Math.floor(sizeConfig.widthMm * pxPerMm);
const heightPx = Math.floor(sizeConfig.heightMm * pxPerMm);

      canvas.className = "muzz-novelty-plate-canvas " +
        (state.face === "White" ? "muzz-novelty-plate-canvas--white" : "muzz-novelty-plate-canvas--yellow") +
        (sizeConfig.shape === "hex" ? " is-hex" : "");

      canvas.style.width = widthPx + "px";
      canvas.style.height = heightPx + "px";
      canvas.innerHTML = buildSvgMarkup(state, config, sizeConfig, state.size, fit);
    }

    function updateFitDisplay(fit) {
      if (!fitEl || !fitLabelEl || !fit) return;

      fitEl.dataset.fitState = fit.fitState;
      fitLabelEl.textContent = fit.fitLabel;
    }

function updatePrice(variant) {
  if (!priceEl) return;
  priceEl.textContent = variant ? formatMoney(variant.price || 0) : "£0.00";
}

function updateAtc(variant, fit) {
  if (!atcButton || !variantIdInput || !atcNote) return;

  const canAdd = !!(
    variant &&
    variant.available &&
    fit.fitState !== "red" &&
    state.largeText &&
    state.notRoadUseAccepted
  );

  atcButton.disabled = !canAdd;
  variantIdInput.value = canAdd ? String(variant.id) : "";

  if (!variant) {
    atcNote.textContent = "No Shopify variant matches this style. Check the novelty product Style variants.";
  } else if (!variant.available) {
    atcNote.textContent = "This style is currently unavailable.";
  } else if (!state.largeText) {
    atcNote.textContent = "Add the main text for your novelty sign.";
  } else if (!state.notRoadUseAccepted) {
    atcNote.textContent = "Confirm this is not for road use before adding to cart.";
  } else if (fit.fitState === "red") {
    atcNote.textContent = "This text is too long for the selected size. Choose a larger sign or shorten the wording.";
  } else {
atcNote.textContent = "Ready to add. Your custom novelty sign will be made as selected.";
  }
}    

function updateChoiceButtons() {
      choiceButtons.forEach(function (button) {
        const target = button.dataset.choiceTarget;
        const value = button.dataset.choiceValue;

        if (state[target] !== undefined) {
          button.classList.toggle("is-active", value === String(state[target]));
        }
      });
    }

    function rerender() {
      if (largeTextInput) {
        state.largeText = sanitizeLargeText(largeTextInput.value);
        largeTextInput.value = state.largeText;
      }

      if (smallTextInput) {
        state.smallText = sanitizeSmallText(smallTextInput.value);
        smallTextInput.value = state.smallText;
      }

      if (styleSelect) state.style = styleSelect.value;
      if (faceSelect) state.face = faceSelect.value;
      if (sizeSelect) state.size = sizeSelect.value;
      if (badgeSelect) state.badge = badgeSelect.value;
      if (borderSelect) state.border = borderSelect.value;
      if (confirmInput) state.notRoadUseAccepted = !!confirmInput.checked;

      enforceBorderRules();
      enforceBadgeRules();

     const sizeConfig = config.sizes[state.size];
const fit = getFitState(state, sizeConfig, state.size, config.charRules);
const variant = resolveVariant();

renderPreview(fit);
updateFitDisplay(fit);
renderWarnings(fit.warnings);
updatePrice(variant);
updateAtc(variant, fit);
updateChoiceButtons();
    }

    choiceButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        const target = button.dataset.choiceTarget;
        const value = button.dataset.choiceValue;

        const targetSelect = root.querySelector('[data-novelty-input="' + target + '"]');

        if (targetSelect) {
          targetSelect.value = value;
          rerender();
        }
      });
    });

    if (largeTextInput) largeTextInput.addEventListener("input", rerender);
    if (smallTextInput) smallTextInput.addEventListener("input", rerender);
    if (styleSelect) styleSelect.addEventListener("change", rerender);
    if (faceSelect) faceSelect.addEventListener("change", rerender);
    if (sizeSelect) sizeSelect.addEventListener("change", rerender);
    if (badgeSelect) badgeSelect.addEventListener("change", rerender);
    if (borderSelect) borderSelect.addEventListener("change", rerender);
    if (confirmInput) confirmInput.addEventListener("change", rerender);

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();

const sizeConfig = config.sizes[state.size];
const fit = getFitState(state, sizeConfig, state.size, config.charRules);
const variant = resolveVariant();

if (!variant || !atcButton || atcButton.disabled || fit.fitState === "red") return;

        atcButton.disabled = true;
        atcButton.textContent = "Adding...";
        if (atcNote) atcNote.textContent = "Adding novelty sign to cart...";

        const item = {
          id: variant.id,
          quantity: 1,
          properties: {
            "Main Text": state.largeText || "",
            "Small Message": state.smallText || "",
            "Style": state.style,
            "Face Colour": state.face,
            "Size": state.size,
            "Badge": state.badge,
            "Border": state.border,
            "Use": "Decorative novelty sign only",
            "Road Use": "Not for road use",
            "Documents Required": "No"
          }
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Add to cart failed");
            return response.json();
          })
          .then(function () {
            return updateCartBubble().then(function () {
              atcButton.textContent = "Added";
              if (atcNote) {
                atcNote.textContent = "Novelty sign added successfully.";
              }
            });
          })
          .catch(function () {
            atcButton.textContent = "Add to cart";
            if (atcNote) atcNote.textContent = "There was a problem adding this item. Please try again.";
          })
          .finally(function () {
            window.setTimeout(function () {
              rerender();
              atcButton.textContent = "Add to cart";
            }, 900);
          });
      });
    }

    rerender();

    let resizeTimer = null;

    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rerender, 120);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-muzz-novelty-builder]").forEach(initBuilder);
  });
})();